import React from 'react';
import { PillChoicePage } from '../components/PillChoicePage';
export function Filming({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <PillChoicePage stepNumber={8} question="Are you willing to film about 1–2 hours of content with us each month over Zoom so we can run your marketing in your voice?" onYes={() => onAnswer('Yes', false)} onNo={() => onAnswer('No', true)} data-id="element-149" />;
}